// 3rd party lib
import moment from 'moment';

// Source files
import COMMON from '../../../../../../common/constants/COMMON';
import DoubleCheckComponent from '../double-check';
import ButtonWarningAM040Component from '../../../../AM040/presenter/component/button-warning';
import { DateColumn, DoubleCheck, TimeSheet } from '../../../../AM004/entity/Entity';
import helpers from '../../../../../../common/helpers/common';


// Image files
import LocationGPSIcon from '../../../../../../assets/icons/location-gps.svg';
import IconI from '../../../../../../assets/icons/icon-i-danger.svg';

import { Tooltip } from 'antd';

export const CHECKIN = 'checkin';
export const CHECKOUT = 'checkout';

const findAttributeByDate = (timesheet: TimeSheet[], date: string, attribute: string) => {
    const foundData: any = timesheet.find((element) =>
        moment(element.date).isSame(moment(date), 'day'),
    );
    if (foundData) return foundData[`${attribute}`];
    return '';
};

const convertToDataSource = (
    userId: number,
    contractorConstructionId: number,
    timesheet: TimeSheet[],
    tableColumns: DateColumn[],
    laborCost: number,
    constructionId: number,
    openStreetMap: (lat: any, lng: any) => void,
) => {
    const columnFrames: any[] = [
        {
            key: 1,
            id: 1,
            name: '複数打刻',
        },
        {
            key: 2,
            id: 2,
            name: '出勤時刻',
        },
        {
            key: 3,
            id: 3,
            name: '退勤時刻',
        },
        {
            key: 4,
            id: 4,
            name: '稼働時間',
        },
        {
            key: 5,
            id: 5,
            name:
                < section style={{ display: 'flex', alignItems: 'center' }}>
                    <div >
                        人工単価（円/日）
                    </div>
                    <Tooltip
                        placement='right'
                        overlayInnerStyle={{
                            width: 370,
                        }}
                        title={<div style={{ width: 'fit-content' }}>
                            8時間を超える残業分については、<br />
                            設定した人工単価に1.25倍の時間単価で計算されます。<br />
                            ※休憩時間を1時間と仮定し計算しております。<br />
                            ※目安金額として参照ください。<br />
                        </div>} >
                        <img alt='' src={IconI} />
                    </Tooltip>
                </section >,
        },
        {
            key: 6,
            id: 6,
            name: ' 担当者確認(出勤)',
        },
        {
            key: 7,
            id: 7,
            name: '担当者確認(退勤)',
        },
    ];
    const result: any[] = [];

    // double check by date
    const doubleCheckDateData: any[] = [];
    timesheet.forEach((timesheetElement: TimeSheet) => {
        if (timesheetElement.doubleCheck && Array.isArray(timesheetElement.doubleCheck)) {
            timesheetElement.doubleCheck?.forEach((doubleCheckElement: DoubleCheck) => {
                doubleCheckDateData.push({
                    ...doubleCheckElement,
                    date: timesheetElement.date,
                    checkinId: timesheetElement.checkinId,
                    checkoutId: timesheetElement.checkoutId,
                });
            });
        }
    });

    // match data
    columnFrames.forEach((frame) => {
        const record: any = {};
        if (frame.id === 1)
            tableColumns.forEach((col) => {
                const foundData: any = timesheet.find((element) =>
                    moment(element.date).isSame(moment(col.value), 'day'),
                );
                const isMultipleCheckInOut = findAttributeByDate(
                    timesheet,
                    col.value,
                    'isMultipleCheckInOut',
                );
                record[`${col.value}`] = isMultipleCheckInOut ? (
                    <ButtonWarningAM040Component
                        constructionId={constructionId + ''}
                        contractorConstructionId={contractorConstructionId + ''}
                        date={moment(foundData.date).format(COMMON.FORMAT_DATE2)}
                        userId={userId + ''}
                    />
                ) : (
                    <></>
                );
            });
        else if (frame.id === 2) {
            tableColumns.forEach((col) => {
                const checkin = findAttributeByDate(timesheet, col.value, 'checkin');
                const checkinLocation = findAttributeByDate(
                    timesheet,
                    col.value,
                    'checkinLocation',
                );
                record[`${col.value}`] = checkin ? (
                    <main style={{ display: 'flex' }}>
                        <div style={{ marginRight: 7 }}>{`${moment(checkin).format(
                            COMMON.FORMAT_TIME1,
                        )}`}</div>
                        {checkinLocation &&
                            checkinLocation?.lat !== 0 &&
                            checkinLocation?.long !== 0 ? (
                            <div
                                className="center-item"
                                onClick={() =>
                                    openStreetMap(checkinLocation?.lat, checkinLocation?.long)
                                }
                            >
                                <img alt="" src={LocationGPSIcon} />
                            </div>
                        ) : (
                            <></>
                        )}
                    </main>
                ) : (
                    <></>
                );
            });
        } else if (frame.id === 3) {
            tableColumns.forEach((col) => {
                const checkout = findAttributeByDate(timesheet, col.value, 'checkout');
                const checkoutLocation = findAttributeByDate(
                    timesheet,
                    col.value,
                    'checkoutLocation',
                );

                record[`${col.value}`] = checkout ? (
                    <main style={{ display: 'flex' }}>
                        <div style={{ marginRight: 7 }}>{`${moment(checkout).format(
                            COMMON.FORMAT_TIME1,
                        )}`}</div>
                        {checkoutLocation &&
                            checkoutLocation?.lat !== 0 &&
                            checkoutLocation?.long !== 0 ? (
                            <div
                                className="center-item"
                                onClick={() =>
                                    openStreetMap(checkoutLocation?.lat, checkoutLocation?.long)
                                }
                            >
                                <img alt="" src={LocationGPSIcon} />
                            </div>
                        ) : (
                            <></>
                        )}
                    </main>
                ) : (
                    <></>
                );
            });
        } else if (frame.id === 4) {
            tableColumns.forEach((col) => {
                const checkin = findAttributeByDate(timesheet, col.value, 'checkin');
                const checkout = findAttributeByDate(timesheet, col.value, 'checkout');
                if (checkin && checkout) {
                    const duration = moment.duration(
                        moment(checkout, COMMON.FORMAT_DATE_4).diff(
                            moment(checkin, COMMON.FORMAT_DATE_4),
                        ),
                    );
                    const totalMinutes = duration.asMinutes();
                    record[`${col.value}`] = `${Math.round((totalMinutes / 60) * 100) / 100}`;
                } else record[`${col.value}`] = <></>;
            });
        } else if (frame.id === 5)
            tableColumns.forEach((col) => {
                const checkin = findAttributeByDate(timesheet, col.value, 'checkin');
                const checkout = findAttributeByDate(timesheet, col.value, 'checkout');
                const dailyLaborCost = findAttributeByDate(timesheet, col.value, 'dailyLaborCost');
                if (checkin && checkout) record[`${col.value}`] = helpers.formatCurrency(dailyLaborCost ?? 0);
                else record[`${col.value}`] = '';
            });
        else if (frame.id === 6) {
            tableColumns.forEach((col) => {
                const user = helpers.getObjectFromLocalStorage('user');
                const companyId = user?.company?.id ?? '';
                if (!companyId) return;
                const foundDoubleCheck = doubleCheckDateData.find(
                    (doubleCheck: any) =>
                        moment(doubleCheck.date).isSame(moment(helpers.getFilterTime(col.value)), 'day') &&
                        doubleCheck.companyId === companyId &&
                        doubleCheck.categoryCode === CHECKIN,
                );
                if (!foundDoubleCheck) {
                    const checkin = findAttributeByDate(timesheet, col.value, 'checkin');
                    const checkinId = findAttributeByDate(timesheet, col.value, 'checkinId');

                    if (checkin)
                        record[`${col.value}`] = (
                            <DoubleCheckComponent
                                constructionId={constructionId}
                                doubleCheck={null}
                                userTimeSheetId={checkinId || 0}
                            />
                        );
                    else record[`${col.value}`] = <></>;
                    return;
                }
                record[`${col.value}`] = (
                    <DoubleCheckComponent
                        constructionId={constructionId}
                        doubleCheck={foundDoubleCheck?.approve ? true : false}
                        userTimeSheetId={foundDoubleCheck?.checkinId || 0}
                    />
                );
            });
        } else {
            // (frame.id === 7)
            tableColumns.forEach((col) => {
                const user = helpers.getObjectFromLocalStorage('user');
                const companyId = user?.company?.id ?? '';
                if (!companyId) return;
                const foundDoubleCheck = doubleCheckDateData.find(
                    (doubleCheck: any) =>
                        moment(doubleCheck.date).isSame(moment(helpers.getFilterTime(col.value)), 'day') &&
                        doubleCheck.companyId === companyId &&
                        doubleCheck.categoryCode === CHECKOUT,
                );
                if (!foundDoubleCheck) {
                    const checkout = findAttributeByDate(timesheet, col.value, 'checkout');
                    const checkoutId = findAttributeByDate(timesheet, col.value, 'checkoutId');

                    if (checkout)
                        record[`${col.value}`] = (
                            <DoubleCheckComponent
                                constructionId={constructionId}
                                doubleCheck={null}
                                userTimeSheetId={checkoutId || 0}
                            />
                        );
                    else record[`${col.value}`] = <></>;

                    return;
                }

                record[`${col.value}`] = (
                    <DoubleCheckComponent
                        constructionId={constructionId}
                        doubleCheck={foundDoubleCheck?.approve ? true : false}
                        userTimeSheetId={foundDoubleCheck?.checkoutId || 0}
                    />
                );
            });
        }
        result.push({ ...frame, ...record });
    });
    // check in
    return result;
};
export { convertToDataSource };
